export enum LogoutReason {
  INVALID_TOKEN = 'invalid-token',
  DROPDOWN_CLICKED = 'user-dropdown-clicked',
}
